/**
 * Phase 5 — Family Assistant bus topics.
 *
 * These topics are the canonical AI event declarations.
 * They are merged into the central eventSchemas in packages/shared/src/events.ts
 * via spread (`...aiEventSchemas`) so the typed bus validates all emits.
 *
 * Consumers import from this file or from the barrel (packages/shared/src/ai/index.ts).
 */
import { z } from 'zod';

// `familyId` (#172): telemetrien i adminpanelet holdes per familie.
export const aiEventSchemas = {
  'ai.message.flushed':   z.object({ familyId: z.string().min(1), memberId: z.string(), conversationId: z.string(), messageId: z.string() }),
  'ai.message.corrected': z.object({ familyId: z.string().min(1), memberId: z.string(), conversationId: z.string(), messageId: z.string(), allergens: z.array(z.string()) }),
  'ai.tool.invoked':      z.object({ familyId: z.string().min(1), memberId: z.string(), tool: z.string(), durationMs: z.number().int().nonnegative() }),
  'ai.shopping_added':    z.object({ familyId: z.string().min(1), memberId: z.string(), itemId: z.string(), text: z.string() }),
  // Wave 2 (v2.0a): one morning-briefing summary generated for a member.
  // `corrected` is true when the allergen scan fired (or the API was
  // unavailable) and the deterministic fallback summary was persisted instead
  // of the AI prose — safety/observability telemetry surfaced in the admin panel.
  'ai.briefing.generated': z.object({ familyId: z.string().min(1), memberId: z.string(), durationMs: z.number().int().nonnegative(), corrected: z.boolean() }),
  // AI-21.6 (#196): nattjobben foreslo notater. `proposed` = kandidater fra
  // modellen, `stored` = lagret som ventende etter vakt og dedup. Bare tall —
  // aldri notattekst — så telemetrien i adminpanelet ikke bærer innhold.
  'ai.memory.suggested': z.object({ familyId: z.string().min(1), proposed: z.number().int().nonnegative(), stored: z.number().int().nonnegative() }),
} as const;

export type AiEventName = keyof typeof aiEventSchemas;
